import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import { withRouter } from 'kts-platform-frame/routes';
import ModulesAction from './Modules.Action';
import Detail from './UI.Detail';
import Bank from './UI.Bank';
import Description from './UI.Description';
import CompanyElegance from './UI.CompanyElegance';
import {
    Button
} from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    // 访问公开首页
    gocompanyPublic = () => {
        let url = window.parent.location.origin + '/companyPublic/' + this.modulesState.companyInfo.companyId;
        window.open(url, '_blank');

    }
    render() {
        return (
            <div className={css.company}>
                <div className={css['company-body']}>
                    <div><a onClick={this.gocompanyPublic}>访问公开首页</a></div>
                    <Detail/>
                    <Bank/>
                    <Description/>
                    <CompanyElegance/>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/UI.Components.tsx